/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import Grid from '@mui/material/Unstable_Grid2';
import Switch, { SwitchProps } from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
} from '@mui/material';
import { toast } from 'react-toastify';
// Context
import useAreaImprovementContext from '../context/useAreaImprovementContext';
// API
import { postAreaStore } from '../../../api/areaImprovementApi';

export default function UpdateAreaModal() {
  const { updateAreaModal, setUpdateAreaModal, area, handleGenerateList } =
    useContext(useAreaImprovementContext);

  const defaultRequest = {
    id: area?.id,
    description: area?.description,
    with_text_input: area?.with_text_input,
    status: area?.status,
  };

  const defaultSegment = area?.segments?.map((row) => ({
    value: row.id,
    label: row.segment,
    active: row.status,
  }));

  const [requestForm, setRequestForm] = useState(defaultRequest);
  const [activeSegments, setActiveSegments] = useState(defaultSegment);

  const handleClose = () => {
    setUpdateAreaModal({ ...updateAreaModal, toggle: false });
  };

  const handleChange = (e) => {
    setRequestForm({ ...requestForm, [e.target.name]: e.target.value });
  };

  const handleOnChangeSwitch = (e, name) => {
    setRequestForm({
      ...requestForm,
      [name]: e.target.checked === true ? 1 : 0,
    });
  };

  const handleSelectSegment = (row, index) => {
    const newArr = [...activeSegments];
    const findRow = activeSegments.find((item) => row.id === item.id);

    newArr[index] = {
      value: row.value,
      label: row.label,
      active: row.active === 0 ? 1 : 0,
    };
    setActiveSegments(newArr);
  };

  const hanldeUpdateArea = async () => {
    try {
      toast.loading('Processing request please kindly wait...');
      const request = {
        id: requestForm?.id,
        description: requestForm?.description,
        with_text_input: requestForm?.with_text_input,
        status: requestForm?.status,
        segments: activeSegments.filter((row) => row.active === 1).map((row) => row.value) ?? [],
      };

      const response = await postAreaStore(request);
      const { code, message } = response.data;

      if (code === '200') {
        toast.success(message);
        setRequestForm(defaultRequest);
        setUpdateAreaModal({
          ...updateAreaModal,
          toggle: false,
        });
        handleGenerateList();
      }

      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  return (
    <Dialog onClose={handleClose} open={updateAreaModal.toggle} fullWidth maxWidth='md'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Update Area for Improvement
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid xs={12} pt={2}>
            <TextField
              fullWidth
              id='description'
              name='description'
              label='Title'
              onChange={(e, newValue) => handleChange(e)}
              mt={1}
              value={requestForm?.description ?? ''}
              size='small'
            />
          </Grid>
          <Grid xs={6} sm={6} md={6}>
            <Switch
              checked={requestForm?.with_text_input === 1}
              color='success'
              size='sm'
              onChange={(event) => handleOnChangeSwitch(event, 'with_text_input')}
            />{' '}
            With Text Input
          </Grid>
          <Grid xs={6} sm={6} md={6}>
            <Switch
              checked={requestForm?.status === 1}
              color='success'
              size='sm'
              onChange={(event) => handleOnChangeSwitch(event, 'status')}
            />{' '}
            Publish Area for Improvement
          </Grid>
          <Grid xs={12} pt={2}>
            Visible To
            <div style={{ marginTop: '20px' }}>
              {activeSegments?.map((row, index) => (
                <Button
                  variant={row.active === 0 ? 'outlined' : 'contained'}
                  size='sm'
                  onClick={() => handleSelectSegment(row, index)}
                  sx={{ margin: '5px' }}
                >
                  {row.label}
                </Button>
              ))}
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='success' onClick={hanldeUpdateArea}>
          Submit
        </Button>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
